import script from "./ControllPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControllPanel.vue?vue&type=script&setup=true&lang=ts"

import "./ControllPanel.vue?vue&type=style&index=0&id=1a3c3430&lang=sass"

const __exports__ = script;

export default __exports__